import { inject, Injectable } from '@angular/core';
import { SeoMetadataService } from '@uc/utilities';
import {
	HEADER_DATA,
	HEADER_CLEARING_DATA,
	METADATA,
} from '../static/universities.properties';
import { Product, ProductEnum } from '@uc/web/shared/data-models';
import { UniversitiesService } from './universities.service';

@Injectable({ providedIn: 'root' })
export class CopyGeneratorService {
	private _seoSrv = inject(SeoMetadataService);
	private _unisSrv = inject(UniversitiesService);

	setSeoData(product: string, location?: string): void {
		const data = structuredClone(METADATA);

		if (location) {
			data.title = `${this.generateTitle(product, location)}`;
		}

		this._seoSrv.updateTitle(data.title);
		this._seoSrv.updateDescription(data.description);
	}

	setHeaderData(product: string, location?: string): void {
		const data =
			product === ProductEnum.Clearing
				? structuredClone(HEADER_CLEARING_DATA)
				: structuredClone(HEADER_DATA);

		if (location) {
			data.title = this.generateTitle(product, location);
		}

		this._unisSrv.headerData.set(data);
	}

	generateTitle(product: string, location: string): string {
		if (product === 'clearing' && location) {
			return `Clearing Universities in ${location}`;
		} else {
			return `Universities in ${location}`;
		}
	}

	getStudyLevelCopy(
		product: Product | undefined,
		studyLevel: 'postgraduate' | 'undergraduate',
	) {
		const clearing = product === 'clearing' ? 'in clearing' : null;
		const copy = `This shows universities offering ${studyLevel} courses ${clearing}, and changes the order, filters and next steps available for your search.`;

		return copy.replace(/\s?null/, '').replace(/\s?,/, ',');
	}
}
